import { Board } from "./Board";
import { CameraManager } from "../../utils/CameraManager";
import { CanvasManager } from "./CanvasManager";
import { GameVars } from "../../GameVars";
import { GuiScene } from "../GUI/GuiScene";
import { GameManager } from "../../GameManager";

export class CanvasScene extends Phaser.Scene {

    public static currentInstance: CanvasScene;
    public gui: GuiScene;
    public board: Board;
    public camManager: CameraManager;

    private currentX: number = 0;
    private currentY: number = 0;
    private mouseDown: boolean = false;

    constructor() {

        super({
            key: "CanvasScene"
        });
    }

    public create(): void {

        CanvasScene.currentInstance = this;
        GameVars.currentScene = this;

        // Will load the matrix of the corresponding level 
        CanvasManager.init(this);

        // Init GUI scene
        this.gui = this.scene.get("GuiScene") as GuiScene;
        this.scene.run("GuiScene", { drawColors: GameVars.drawColors });

        // Create the board 
        this.board = new Board(this);
        this.board.createDrawing();
        this.add.existing(this.board);

        // Add cam manager
        this.camManager = new CameraManager(this.cameras.main, CanvasScene.currentInstance, true, this.board);

        // In case the user is painting, the camera should not dragg

        this.input.on("pointerupoutside", function () {

            this.unclickPointer();

        }, this);

        this.input.on("pointerdown", function () {

            if (GameVars.currentScene !== this) {
                return;
            }

            this.mouseDown = true;

            let cellPos = CanvasManager.getCellFromScreenPos();

            if (cellPos) {
                const cell = GameVars.pixelTiles[cellPos.y][cellPos.x];

                if (cell) {

                    cell.onCellDown();

                    this.currentX = cellPos.x;
                    this.currentY = cellPos.y;
                }
            }
        }, this);

        this.input.on("pointerup", function () {

            if (GameVars.currentScene !== this) {
                return;
            }

            this.mouseDown = false;

            if (!CanvasManager.isMouseInDraw()) {
                GameManager.captureMouseRelease();
            }

            if (this.camManager.hasDragged) { 
                return; }

            let cellPos = CanvasManager.getCellFromScreenPos();
            if (cellPos) {

                const cell = GameVars.pixelTiles[cellPos.y][cellPos.x];

                if (cell) {
                    cell.onCellUp();

                    this.currentX = cellPos.x;
                    this.currentY = cellPos.y;
                }
            }
        }, this);

        this.input.on("pointermove", function () {

            if (GameVars.currentScene !== this) {
                return;
            }

            if (this.mouseDown === false) {
                return;
            }

            const cellPos = CanvasManager.getCellFromScreenPos();

            if (cellPos) {

                const cell = GameVars.pixelTiles[cellPos.y][cellPos.x];
                if (cell) {

                    cell.onCellMove();

                    this.currentX = cellPos.x;
                    this.currentY = cellPos.y;
                }
            }

        }, this);
    }

    public update(time: number, delta: number): void {

        super.update(time, delta);

        // Update Camera
        this.camManager.update(delta);
        CanvasManager.update(delta);
    }

    public unclickPointer(): void {

        this.mouseDown = false;
        this.camManager.onPointerUp();
        this.gui.onPointerUp();
    }
}
